// extracted by mini-css-extract-plugin
export default {"homeproduct__wrapper":"home_homeproduct__wrapper__Tiad8","handwear__wrapper":"home_handwear__wrapper__CjrhW"};